export interface GusQuery {
  userId: string;
  estateId: string;
  createDate: number;
  state: GusQueryState;
  query: {
    type: GusQueryType;
    param?: string;
  };
  sessionId?: string;
  nipResponse?: GusQueryResponse;
}

export enum GusQueryState {
  CREATED = 'created',
  LOGGED_IN = 'logged_in',
  CONNECTION_ERROR = 'connection_error',
  DATA_ERROR = 'data_error'
}

export enum GusQueryType {
  GET_NIP = 'get_nip',
  LOGOUT = 'logout'
}

export interface GusQueryResponse {
  regon: string;
  statusNip: string;
  name: string;
  voivodeship: string; // ? województwo
  county: string; // ? powiat
  commune: string; // ? gmina
  city: string;
  zipCode: string;
  zipCodeCity: string;
  street: string;
  buildingNumber: string;
  premisesNumber: string; // ? nr lokalu
  type: string;
  silosId: number;
  dateOfTermination: number;
}
